// Import Dependencies
import { Navigate, useOutlet } from "react-router";

// Local Imports
import { useAuthContext } from "app/contexts/auth/context";
import { HOME_PATH, REDIRECT_URL_KEY } from "constants/app.constant";

// ----------------------------------------------------------------------


export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated } = useAuthContext();

  const redirectParam = new URLSearchParams(window.location.search).get(
    REDIRECT_URL_KEY,
  );
  const redirectUrl = redirectParam && redirectParam !== "null" ? redirectParam : null;

  if (isAuthenticated) {
    if (redirectUrl) {
      return <Navigate to={redirectUrl} />;
    }
    return <Navigate to={HOME_PATH} replace />;
  }

  return <>{outlet}</>;
}
